import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  title?: string;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ChartWrapper extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ChartWrapper: Chart rendering error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const defaultFallback = (
        <div className="flex items-center justify-center h-64 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg">
          <div className="text-center p-6">
            <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-3" />
            <h4 className="font-semibold text-red-900 dark:text-red-300 mb-2">
              Chart Error
            </h4>
            <p className="text-red-700 dark:text-red-200 text-sm mb-3">
              {this.props.title ? `Failed to render ${this.props.title}` : 'Failed to render chart'}
            </p>
            <p className="text-red-600 dark:text-red-400 text-xs">
              {this.state.error?.message || 'Unknown error occurred'}
            </p>
            <button
              onClick={() => this.setState({ hasError: false, error: undefined })}
              className="mt-3 px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      );

      return this.props.fallback || defaultFallback;
    }

    return this.props.children;
  }
}

export default ChartWrapper;